__turbopack_context__.v({
  "actions": "ChatbotsHeader-module__xwk8Kq__actions",
  "ownerFilter": "ChatbotsHeader-module__xwk8Kq__ownerFilter",
  "root": "ChatbotsHeader-module__xwk8Kq__root",
  "sharing": "ChatbotsHeader-module__xwk8Kq__sharing",
});
